import GroupCard from './GroupCard.vue'
import GroupImport from './GroupImport.vue'

const groupsComponents = {
  install(Vue) {
    Vue.component(GroupCard.name, GroupCard)
    Vue.component(GroupImport.name, GroupImport)
  }
}

export default groupsComponents
